import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { __ } from "services/Translator";
import DOMPurify from "dompurify";
import Winner from "elements/Winner";
import LatestWinner from "elements/LatestWinner";
import api from "services/api";

export default function GameDetails(props) {
  // game details tab
  const [gameDetailsTab, setGameDetailsTab] = useState("Game Description");

  // bets  tab

  const [betsTab, setBetsTab] = useState("Big Bets");
  const [isFavorite, setIsFavorite] = useState(
    props.gameDetails.is_favorite_game
  );
  const toggleFavoriteGame = async () => {
    var response = await api.post("/toggle-favorite-game", {
      gameId: props.gameDetails.id,
    });
    if (response.status === 200) {
      if (response.data.status === "added") {
        setIsFavorite(true);
      } else {
        setIsFavorite(false);
      }
    }
  };

  useEffect(() => {
    setIsFavorite(props.gameDetails.is_favorite_game);
  }, [props]);
  return (
    <>
      <section className="game_details">
        <div className="container">
          <div className="game_details_area">
            <div className="game_thumb">
              {/* <img
                alt="Game image"
                src="https://chimpbytes.imgix.net/game-5.png?&dpr=2&format=auto&auto=format&q=1&w=264&h=372&max-age=2629056"
              /> */}
              <img alt="Game image" src={props.gameDetails.game_snapshot_url} />
            </div>
            <div className="game_details_text">
              <div className="tabing_area">
                <div
                  onClick={() => setGameDetailsTab("Game Description")}
                  className={
                    gameDetailsTab === "Game Description"
                      ? "item active"
                      : "item"
                  }
                >
                  <span
                    className={
                      gameDetailsTab === "Game Description"
                        ? "indicate show"
                        : "indicate"
                    }
                  ></span>
                  {__("Game Description")}
                </div>

                {/* <div
                  onClick={() => setGameDetailsTab("How to Play")}
                  className={
                    gameDetailsTab === "How to Play" ? "item active" : "item"
                  }
                >
                  <span
                    className={
                      gameDetailsTab === "How to Play"
                        ? "indicate show"
                        : "indicate"
                    }
                  ></span>
                  {__("How to Play")}
                </div> */}

                <div
                  onClick={() => setGameDetailsTab("Latest Winners")}
                  className={
                    gameDetailsTab === "Latest Winners" ? "item active" : "item"
                  }
                >
                  <span
                    className={
                      gameDetailsTab === "Latest Winners"
                        ? "indicate show"
                        : "indicate"
                    }
                  ></span>
                  {__("Latest Winners")}
                </div>
              </div>

              {gameDetailsTab == "Game Description" && (
                <div className="game_description slideUpAnimation">
                  <div className="game_name">{props.gameDetails.game_name}</div>
                  <div
                    className="paragraph"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        props.gameDetails?.game_seo_content?.content
                      ),
                    }}
                  ></div>
                </div>
              )}

              {gameDetailsTab == "How to Play" && (
                <div className="game_description slideUpAnimation">
                  <div className="game_name">{props.gameDetails.game_name}</div>
                  <div
                    className="paragraph"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        props.gameDetails?.game_seo_content?.content
                      ),
                    }}
                  ></div>
                </div>
              )}

              {gameDetailsTab == "Latest Winners" && (
                <div className="game_description slideUpAnimation">
                  <LatestWinner
                    title=""
                    gameId={props.gameDetails.game_id}
                    {...props}
                  />
                </div>
              )}

              <div className="game_summery">
                <div className="item">
                  {props.isAuthenticated && (
                    <Link
                      onClick={toggleFavoriteGame}
                      className="favorite_icon"
                    >
                      {isFavorite ? (
                        <>
                          <svg
                            width="20"
                            height="18"
                            viewBox="0 0 20 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_2081_3472)">
                              <path
                                d="M14.6 0C12.5 0 10.8 1.3 10 2C9.2 1.3 7.4 0 5.4 0C2.4 0 0 2.4 0 5.4C0 7.2 1.7 8.9 1.8 9L10 17.2L18.2 9C18.3 8.9 20 7.2 20 5.4C20 2.4 17.6 0 14.6 0Z"
                                fill="#4698ED"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2081_3472">
                                <rect width="20" height="17.2" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </>
                      ) : (
                        <>
                          <svg
                            width="20"
                            height="18"
                            viewBox="0 0 20 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_2081_1449)">
                              <path
                                d="M5.4 0C2.4 0 0 2.4 0 5.4C0 6.4 0.5 7.3 0.9 7.9C1.3 8.5 1.8 8.9 1.8 8.9L9.5 16.6L10 17.1L10.5 16.6L18.2 9C18.2 9 20 7.4 20 5.4C20 2.4 17.6 0 14.6 0C12.1 0 10.6 1.5 10 2.1C9.4 1.5 7.8 0 5.4 0ZM5.4 1.4C7.5 1.4 9.5 3.5 9.5 3.5L10 4.1L10.5 3.5C10.5 3.5 12.5 1.4 14.6 1.4C16.8 1.4 18.5 3.2 18.5 5.3C18.5 6.4 17.2 7.9 17.2 7.9L10 15.2L2.8 7.9C2.8 7.9 2.5 7.6 2.1 7.1C1.7 6.6 1.4 5.9 1.4 5.4C1.4 3.2 3.2 1.4 5.4 1.4Z"
                                fill="#4698ED"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_2081_1449">
                                <rect width="20" height="17.2" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </>
                      )}{" "}
                      {__(" ")}
                      {__("Add this game to your favourites.")}
                    </Link>
                  )}{" "}
                </div>
                <div className="item border_right_none">
                  <i className="far fa-eye"> </i> {props.gameDetails.views}
                </div>
                {/* <div className="item border_right_none">
                  {__("Big win 150,000")}{" "}
                </div> */}
              </div>
            </div>
            <div className="swith_area d-none">
              <label class="switch">
                <input type="checkbox" />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </section>
      <div className="container-xxl container-xl">
        <br />
        <Winner {...props} />
      </div>
      <section className="bet_info d-none">
        <div className="container">
          <div className="section_headline">
            <div className="headline_text">{__("Popular Games")}</div>
          </div>
          <div className="tabing_area">
            <div
              onClick={() => setBetsTab("Big Bets")}
              className={betsTab === "Big Bets" ? "item active" : "item"}
            >
              <span
                className={
                  betsTab === "Big Bets" ? "indicate show" : "indicate"
                }
              ></span>
              {__("Big Bets")}
            </div>

            <div
              onClick={() => setBetsTab("Tab2")}
              className={betsTab === "Tab2" ? "item active" : "item"}
            >
              <span
                className={betsTab === "Tab2" ? "indicate show" : "indicate"}
              ></span>
              {__("Information")}
            </div>

            <div
              onClick={() => setBetsTab("Tab3")}
              className={betsTab === "Tab3" ? "item active" : "item"}
            >
              <span
                className={betsTab === "Tab3" ? "indicate show" : "indicate"}
              ></span>
              {__("Information")}
            </div>

            <div
              onClick={() => setBetsTab("Tab4")}
              className={betsTab === "Tab4" ? "item active" : "item"}
            >
              <span
                className={betsTab === "Tab4" ? "indicate show" : "indicate"}
              ></span>
              {__("Information")}
            </div>
          </div>
          <div className="datasets">
            <div className="single_dataset">
              <div className="item">
                <div className="user">
                  <div className="profile_img">
                    <img
                      src={
                        require("../../assets/images/new-landing/user.jpg")
                          .default
                      }
                      alt="game image"
                    />
                  </div>
                  <div className="profile_text">
                    <div className="text_white">Eddy Mendez</div>
                    <div className="online_indicate">
                      <i class="fas fa-circle"></i> {__("Online")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="text_white">Forge of Fortune</div>
                <div className="text_white gray">{__("Challenge")}</div>
              </div>
              <div className="item">
                <div className="dased"></div>
                <div className="trophy">
                  <i class="fas fa-trophy"></i>
                  <span className="text_white">25</span>{" "}
                  <span className="text_white gray">{__("big price")}</span>
                </div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Bet amount")}</div>
                <div className="text_white">7.97850018</div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Multiplier")}</div>
                <div className="text_white">02 : 15 : 11</div>
              </div>
              <div className="item">
                <button className="label_btn">{__("Lorem Ipsum")}</button>
              </div>
            </div>
            <div className="single_dataset">
              <div className="item">
                <div className="user">
                  <div className="profile_img">
                    <img
                      src={
                        require("../../assets/images/new-landing/user.jpg")
                          .default
                      }
                      alt="game image"
                    />
                  </div>
                  <div className="profile_text">
                    <div className="text_white">Eddy Mendez</div>
                    <div className="online_indicate">
                      <i class="fas fa-circle"></i> {__("Online")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="text_white">Forge of Fortune</div>
                <div className="text_white gray">{__("Challenge")}</div>
              </div>
              <div className="item">
                <div className="dased"></div>
                <div className="trophy">
                  <i class="fas fa-trophy"></i>
                  <span className="text_white">25</span>{" "}
                  <span className="text_white gray">{__("big price")}</span>
                </div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Bet amount")}</div>
                <div className="text_white">7.97850018</div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Multiplier")}</div>
                <div className="text_white">02 : 15 : 11</div>
              </div>
              <div className="item">
                <button className="label_btn">{__("Lorem Ipsum")}</button>
              </div>
            </div>
            <div className="single_dataset">
              <div className="item">
                <div className="user">
                  <div className="profile_img">
                    <img
                      src={
                        require("../../assets/images/new-landing/user.jpg")
                          .default
                      }
                      alt="game image"
                    />
                  </div>
                  <div className="profile_text">
                    <div className="text_white">Eddy Mendez</div>
                    <div className="online_indicate">
                      <i class="fas fa-circle"></i> {__("Online")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="text_white">Forge of Fortune</div>
                <div className="text_white gray">{__("Challenge")}</div>
              </div>
              <div className="item">
                <div className="dased"></div>
                <div className="trophy">
                  <i class="fas fa-trophy"></i>
                  <span className="text_white">25</span>{" "}
                  <span className="text_white gray">{__("big price")}</span>
                </div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Bet amount")}</div>
                <div className="text_white">7.97850018</div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Multiplier")}</div>
                <div className="text_white">02 : 15 : 11</div>
              </div>
              <div className="item">
                <button className="label_btn">{__("Lorem Ipsum")}</button>
              </div>
            </div>
            <div className="single_dataset">
              <div className="item">
                <div className="user">
                  <div className="profile_img">
                    <img
                      src={
                        require("../../assets/images/new-landing/user.jpg")
                          .default
                      }
                      alt="game image"
                    />
                  </div>
                  <div className="profile_text">
                    <div className="text_white">Eddy Mendez</div>
                    <div className="online_indicate">
                      <i class="fas fa-circle"></i> {__("Online")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="text_white">Forge of Fortune</div>
                <div className="text_white gray">{__("Challenge")}</div>
              </div>
              <div className="item">
                <div className="dased"></div>
                <div className="trophy">
                  <i class="fas fa-trophy"></i>
                  <span className="text_white">25</span>{" "}
                  <span className="text_white gray">{__("big price")}</span>
                </div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Bet amount")}</div>
                <div className="text_white">7.97850018</div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Multiplier")}</div>
                <div className="text_white">02 : 15 : 11</div>
              </div>
              <div className="item">
                <button className="label_btn">{__("Lorem Ipsum")}</button>
              </div>
            </div>
            <div className="single_dataset">
              <div className="item">
                <div className="user">
                  <div className="profile_img">
                    <img
                      src={
                        require("../../assets/images/new-landing/user.jpg")
                          .default
                      }
                      alt="game image"
                    />
                  </div>
                  <div className="profile_text">
                    <div className="text_white">Eddy Mendez</div>
                    <div className="online_indicate">
                      <i class="fas fa-circle"></i> {__("Online")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div className="text_white">Forge of Fortune</div>
                <div className="text_white gray">{__("Challenge")}</div>
              </div>
              <div className="item">
                <div className="dased"></div>
                <div className="trophy">
                  <i class="fas fa-trophy"></i>
                  <span className="text_white">25</span>{" "}
                  <span className="text_white gray">{__("big price")}</span>
                </div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Bet amount")}</div>
                <div className="text_white">7.97850018</div>
              </div>
              <div className="item">
                <div className="text_white gray">{__("Multiplier")}</div>
                <div className="text_white">02 : 15 : 11</div>
              </div>
              <div className="item">
                <button className="label_btn">{__("Lorem Ipsum")}</button>
              </div>
            </div>

            <div className="load_more">
              {__("Show More")} <i class="far fa-angle-down"></i>
              {/* <i class="far fa-angle-up"></i> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
